import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../../utils/sortFunctions';
import ResultsTable from '../../../table/ResultsTable';

import SelectBarriersTableRow from './SelectBarriersTableRow';

const headCells = [
    { id: 'select', numeric: false, label: 'Select', sortable: false },
    { id: 'name', numeric: false, label: 'Barrier Name' },
    { id: 'priority', numeric: false, label: 'Priority (Low/Medium/High)', sortable: false },
    { id: 'startDate', numeric: false, label: 'Start Date', sortable: false },
    { id: 'dueDate', numeric: false, label: 'Due Date', sortable: false }
];

const initialRowMetaData = {
    order: 'asc',
    orderBy: 'barrierName',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const SelectBarriersTableManagement = ({ onRowsUpdated, barrierNameDetails }) => {
    // LOCAL STATE
    const [updatedRows, setUpdatedRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );

    // USE EFFECTS
    useEffect(() => {
        const currentDate = new Date().toISOString().slice(0, 10);

        setUpdatedRows(
            barrierNameDetails.map((el) => ({
                participantId: currentParticipant.id,
                id: el.id,
                name: el.name,
                priority: 'Medium',
                startDate: currentDate,
                dueDate: currentDate
            }))
        );
    }, []);

    // HELPER FNS
    const createRows = () => {
        return stableSort(updatedRows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <SelectBarriersTableRow key={el.id} row={el} roles={roles} onRowChange={onRowChange} />
        ));
    };

    // EVENT HANDLERS
    const onRowChange = (row, invalidDate) => {
        const rows = updatedRows.map((el) => (el.id === row.id ? row : el));
        setUpdatedRows(rows);
        onRowsUpdated(rows, invalidDate);
    };

    // RENDER
    return (
        <div>
            {updatedRows.length < 1 ? (
                <div>No barriers found</div>
            ) : (
                <ResultsTable
                    defaultOrderBy={rowMetaData.orderBy}
                    sortOrder={rowMetaData.order}
                    headCells={headCells}
                    passRowMetaDataUp={setRowMetaData}
                    tableRows={createRows()}
                    totalResults={updatedRows.length}
                />
            )}
        </div>
    );
};

SelectBarriersTableManagement.propTypes = {
    onRowsUpdated: PropTypes.func,
    barrierNameDetails: PropTypes.array
};

export default SelectBarriersTableManagement;
